import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=951faaea&scoped=true"
import script from "./verificationList.vue?vue&type=script&lang=js"
export * from "./verificationList.vue?vue&type=script&lang=js"
import style0 from "./verificationList.vue?vue&type=style&index=0&id=951faaea&prod&lang=less&scoped=true"
import style1 from "./verificationList.vue?vue&type=style&index=1&id=951faaea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951faaea",
  null
  
)

export default component.exports